/**
 * Promo showcase (sections/promo-showcase.liquid): the type filters and the arrows.
 *
 * The row is a plain horizontal scroller, so it works by touch and trackpad on its own; the
 * arrows move it a card-width at a time and grey out at either end.
 */
(function () {
  class PromoShowcase extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector("[data-ps-track]");
      this.prev = this.querySelector("[data-ps-prev]");
      this.next = this.querySelector("[data-ps-next]");
      this.filters = Array.prototype.slice.call(this.querySelectorAll("[data-ps-filter]"));
      if (!this.track) return;

      var self = this;
      this.prev && this.prev.addEventListener("click", function () {
        self.step(-1);
      });
      this.next && this.next.addEventListener("click", function () {
        self.step(1);
      });
      this.track.addEventListener("scroll", function () {
        self.updateArrows();
      }, { passive: true });
      window.addEventListener("resize", function () {
        self.updateArrows();
      });

      this.filters.forEach(function (button) {
        button.addEventListener("click", function () {
          self.filter(button);
        });
      });

      this.updateArrows();
    }

    step(direction) {
      var item = this.track.querySelector(".pshow-item:not([hidden])");
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      var width = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
      // A full view at a time on wide screens, one card at a time where only one or two show.
      var perView = Math.max(1, Math.floor((this.track.clientWidth + gap) / width));
      this.track.scrollBy({ left: direction * width * perView, behavior: "smooth" });
    }

    filter(button) {
      var type = button.getAttribute("data-ps-filter");
      this.filters.forEach(function (other) {
        var on = other === button;
        other.classList.toggle("is-active", on);
        other.setAttribute("aria-pressed", on ? "true" : "false");
      });
      // An item marked data-ps-keep (the used lot's trade-in card) stays through every filter.
      Array.prototype.forEach.call(this.track.querySelectorAll(".pshow-item:not([data-ps-keep])"), function (item) {
        item.hidden = type !== "" && item.getAttribute("data-ps-type") !== type;
      });
      this.track.scrollTo({ left: 0 });
      this.updateArrows();
    }

    updateArrows() {
      if (!this.prev || !this.next) return;
      var max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max;
      this.classList.toggle("pshow-fits", max <= 0);
    }
  }

  if (!customElements.get("promo-showcase")) {
    customElements.define("promo-showcase", PromoShowcase);
  }
})();
